import React from 'react';
export function PainSection() {
  return <section className="py-12 px-6 max-w-2xl mx-auto" data-id="element-23">
      <div className="bg-[#2A2520] p-8 md:p-10 rounded-2xl shadow-xl shadow-black/20 border border-[#3A3330]" data-id="element-24">
        <h2 className="text-3xl font-bold text-[#F5F0EB] mb-6" data-id="element-25">
          Tienes miedo de fallar.
        </h2>

        <p className="text-lg text-[#A89B8C] mb-8 leading-relaxed" data-id="element-26">
          Tienes miedo de que el trazo quede muy profundo, de que la tinta se
          expanda o de que la ceja quede asimétrica. Miras tus herramientas y
          sientes un nudo en el estómago en lugar de emoción.
        </p>

        <div className="bg-[#1E1B19] p-6 rounded-xl border-l-4 border-[#C5A55A]" data-id="element-27">
          <h3 className="text-xl font-bold text-[#C5A55A] mb-3 font-serif" data-id="element-28">
            El problema no eres tú.
          </h3>
          <p className="text-[#A89B8C] leading-relaxed" data-id="element-29">
            El problema es que te enseñaron la{' '}
            <span className="italic font-medium text-[#F5F0EB]" data-id="element-30">teoría</span>{' '}
            del diseño, pero nadie entrenó tus{' '}
            <span className="italic font-medium text-[#F5F0EB]" data-id="element-31">músculos</span>.
            Ser artista de cejas no es saber dibujar; es saber controlar la
            presión, el ángulo y la vibración de la mano.
            <br data-id="element-32" />
            <br data-id="element-33" />
            <strong className="text-[#F5F0EB]" data-id="element-34">Es pura física.</strong>
          </p>
        </div>
      </div>
    </section>;
}